export const MONTHS_IN_YEAR = 12;
/** How much months to place in row on calendar page. */
export const MONTH_PAGE_WIDTH = 3;
